import { GroupSelect } from "../../../../components/invoice/group-select";
import { getLS } from "../../../../utils/useLS";
import { createStateContext } from "react-use";
import React, { useEffect } from "react";
import { useState } from "react";
import ProductsGrid from "../../../../components/invoice/item-grid";
import SearchBox from "../../../../components/invoice/search-box";
import { colors, Divider, Grid, Paper, Typography } from "@material-ui/core";
import { GroupsRest } from "../../../../components/invoice/GroupsRest";
import GroupLists from "./GroupLists";
import RestItems from "./RestItems";
import { sto } from "../../../../Context/InshData";
import axios from "axios";
import { uri } from "../../../../help/Api";
import RestItemsG from "./RestItemsG";

export const [useSharedGroupId, SharedGroupIdProvider] = createStateContext(-1);

export function RestProductsG(props) {
    const { dataTable, groups, groupsSub, permistionInv ,valueSafes} = props;
    const locSto = getLS("sto", {});
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [groupId, setGroupId] = useState(-1);

    const [subGroupId, setSubGroupId] = useState(-1);
    const [GroupColor, setGroupColor] = useState({});
    const [group, setGroup] = useState({});

    const [subGroups, setSubGroups] = useState([]);


    const onRowClick = (row) => {
        setGroupId(row.id);
        setGroupId(row.id);
        setGroupColor({ ...row, color: colors.blue[300] });
        setSubGroups([]);

        const subs = groupsSub?.filter((g) => g.parentId == row.id);
        setSubGroups(subs);
        setGroup(row);

        if (subs?.length > 0) {
            setSubGroupId(subs[0]?.id);
            setGroup(row);
        }
        else {
            setSubGroupId(row.id);
            setGroup(row);
        }
        viewHandle(row.id);
    };
    const onRowClickSub = (row) => {
        setGroupId(row.id);
        setGroupId(row.id);
        let clickColor = 8421504;
        setGroupColor({ ...row, color: colors.blue[300] });
        setSubGroupId(row.id);
        setGroup(row);
        viewHandle(row.id);

    };
    useEffect(() => {
    }, [subGroupId, dataTable]);
    const [page, setPage] = useState(0);
    const [loadmore, setLoadmore] = useState(true);
    const viewHandleold = async (group_id) => {
        setData([]);
        setLoading(true);
        await axios
            .get(
                uri +
                `RptSafes/ItemsSearchRest?currShow=${"C"}
        &&curr_type=${-1}
    &&groupid=${group_id}
    &&take=${100}
    &&item_code=${''}
    &&item_name=${''}
    &&emp=${sto.empi}&&withVal=${permistionInv.SIM == false?0:1}&&safe=${valueSafes.id}`
            )
            .then((res) => {
                const dataItems = res.data.map((row, i) => {
                    return {
                        ...row,
                        val1: 1,
                        val:0,

                    };
                });
                setData(dataItems);
                setLoading(false);
                // setIsSearch(false);
            })
            .catch((err) => {
                setLoading(false);
                setData([]);
            });

    };
    const viewHandle = async (group_id) => {
        setData([]);
        setLoading(true);
        await axios
            .get(
                uri +
                `RptSafes/ItemsSearch?currShow=${"C"}
        &&curr_type=${-1}
    &&groupid=${group_id}
    &&take=${100}
    &&item_code=${''}
    &&item_name=${''}
    &&emp=${sto.empi}`
            )
            .then((res) => {
                const dataItems = res.data.map((row, i) => {
                    return {
                        ...row,
                        val1: 1,
                        val:0,

                    };
                });
                setData(dataItems);
                setLoading(false);
                // setIsSearch(false);
            })
            .catch((err) => {
                setLoading(false);
                setData([]);
            });

    };

    return (
        <React.Fragment>
            <Paper
                style={{
                    // backgroundColor: colors.green[50],
                    maxHeight: 600,
                    overflow: "auto",
                }}
            >
                <div >

                    <Typography
                        component="div"
                        style={{ direction: "rtl" }}
                    >

                        <Grid item xs={12} container spacing={0} >

                            <Grid item lg={2} md={2} sm={4} xs={3}>
                                <SharedGroupIdProvider>
                                    <GroupLists
                                        groups={[...groups]}
                                        onRowClick={onRowClick}
                                        isMain={true}
                                        GroupColor={GroupColor}

                                    />
                                    <Divider />

                                </SharedGroupIdProvider>
                            </Grid>

                            {subGroups.length > 0 ? (
                                <>

                                    <Grid item lg={2} md={2} sm={2} xs={3}>
                                        <SharedGroupIdProvider>
                                            <GroupLists
                                                groups={[...subGroups]}
                                                onRowClick={onRowClickSub}
                                                isMain={false}
                                                GroupColor={GroupColor}
                                            />
                                        </SharedGroupIdProvider>
                                    </Grid>
                                    <Grid item lg={8} md={8} sm={8} xs={3}>
                                        <SharedGroupIdProvider>
                                            {/* <SearchBox /> */}


                                            <RestItemsG
                                                onSelectItem={props.onSelectItem}
                                                values={dataTable}
                                                groupId={subGroupId}
                                                BefrowDataCurrencie={null}
                                                group={group}
                                                data={data ? data : []}
                                                loading={loading}
                                            />
                                        </SharedGroupIdProvider>
                                    </Grid>
                                </>
                            ) :
                                (
                                    <Grid item lg={10} md={10} sm={10} xs={10}>
                                        <SharedGroupIdProvider>
                                            {/* <SearchBox /> */}
                                            <RestItemsG
                                                onSelectItem={props.onSelectItem}
                                                values={dataTable}
                                                groupId={subGroupId}
                                                BefrowDataCurrencie={null}
                                                group={group}
                                                data={data ? data : []}
                                                loading={loading}
                                            />
                                        </SharedGroupIdProvider>
                                    </Grid>
                                )
                            }
                        </Grid>
                    </Typography>
                </div>
            </Paper>
        </React.Fragment>
    );
}
